import React, { Component } from 'react';
import './Gallery.css';
import GalleryImages from './gallery-images/GalleryImages';
import {
  convertObjectToArray,
  hideComponent } from '../../redux/helpers';
import ScrollArrow from '../scroll-arrow/ScrollArrow';
import MediaQuery from 'react-responsive';

class Gallery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayTopArrow: false,
      displayBottomArrow: false,
      hideComponent: false,
    };
  }

  componentWillMount() {
    if (hideComponent()) {
      this.setState({
        hideComponent: true,
      });
    }
  }

  /* componentDidUpdate(nextProps) {
    if (nextProps.images.length !== this.props.images.length) {
      this.toggleArrow();
    }
  } */

  slideMobile = (direction) => {
    const gallery = document.querySelector('.GalleryWrapper');

    if(direction === 'right') {
      gallery.scrollLeft += 200;
    } else {
      gallery.scrollLeft -= 200;
    }
  }

  toggleArrow = () => {
    const target = document.querySelector('.GalleryWrapper');
    if (target) {
      const targetOffsetHeight = target.clientHeight;
      const targetScrollHeight = target.scrollHeight;

      if (targetScrollHeight === targetOffsetHeight) {
        this.toggleBottomArrow(false);
      }

      if (targetScrollHeight > targetOffsetHeight) {
        this.toggleBottomArrow(true);
      }
    }
  }

  toggleTopArrow = (visible) => {
    this.setState({
      displayTopArrow: visible,
    });
  }

  toggleBottomArrow = (visible) => {
    this.setState({
      displayBottomArrow: visible,
    });
  }

  displayArrow = (direction, target, state) => (
    state ?
      <ScrollArrow
        direction={direction}
        classes="ScrollLeft galleryScroll"
        target={target}
        vertical={false}
      />
      :
      ''
  )

  renderGalleryImages = () => {
    const imagesArray = convertObjectToArray(this.props.images);
    
    const { lang } = this.props;

    const {
      hideComponent,
      displayTopArrow,
      displayBottomArrow,
    } = this.state;

    if (hideComponent) {
      return false;
    }

    return (
      <div className="Gallery" data-html2canvas-ignore>
        {this.displayArrow('left', '.GalleryWrapper', displayTopArrow)}
        <div className={`scrollLeftMobile`} onClick={() => this.slideMobile('left')}>
          <i
            className={`fa fa-arrow-left`}
          />
        </div>
        <GalleryImages
          toggleTopArrow={this.toggleTopArrow.bind(this)}
          toggleBottomArrow={this.toggleBottomArrow.bind(this)}
          images={imagesArray}
          imageslength={imagesArray.length}
        />
        <div className={`scrollRightMobile`} onClick={() => this.slideMobile('right')}>
          <i
            className={`fa fa-arrow-right`}
          />
        </div>
        {this.displayArrow('right', '.GalleryWrapper', displayBottomArrow)}
        <MediaQuery maxWidth={991} orientation='portrait'>
          <span className='GalleryText'>{lang.drag_the_photo_to_the_calendar}</span>
        </MediaQuery>
      </div>
    );
  }

  render() {
    return (
      this.renderGalleryImages()
    );
  }
}

export default Gallery;



// WEBPACK FOOTER //
// ./src/components/gallery/Gallery.jsx